export default __webpack_public_path__ + "static/media/spaceshooter.efac87b8.jpeg";